import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { PRD3060_R01Dto } from "./Dto_PRD3060_R01";
import { Content_PRD3060_R01 } from "./Content_PRD3060_R01";
import { Detailtable_PRD3060_R01 } from "./Detailtable_PRD3060_R01";
import { SearchSection_PRD3060_R01 } from "./SearchSection_PRD3060_R01";
import { usePRD3060_R01Store } from "./Store_PRD3060_R01";
import { Table_PRD3060_R01 } from "./Table_PRD3060_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

export const Container_PRD3060_R01 = () => {
    const { initData } = usePRD3060_R01Store();
    const { setMessage } = useUiuxStore();

    const gridRef = useRef<AgGridReact<PRD3060_R01Dto>>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const detailTableRef = useRef<HTMLDivElement>(null);
    const isResizing = useRef(false);

    const RESIZER = {
        code: "PRD3060_R01-main",
        type: "width" as const,
        storageKey: "PRD3060_R01-main-split-width",
        min: 20,
        max: 90,
        default: 65,
    } as const;

    const { splitValue, handleMouseDown } = useMouseContent({
        resizer: RESIZER,
        isResizing,
        containerRef,
        infoRef: detailTableRef,
    });

    const { fetchData, fetchDetailList, handlePrint } = Content_PRD3060_R01({ setMessage });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onPrintClick={handlePrint}
                onSaveClick={undefined}
                onDeleteClick={undefined}
                onInitClick={initData}
            />

            <SearchSection_PRD3060_R01 />

            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
                <div className="h-full" style={{ width: `${splitValue}%` }}>
                    <Table_PRD3060_R01
                        gridRef={gridRef}
                        onRowClick={fetchDetailList}
                    />
                </div>

                <div
                    className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
                    onMouseDown={(e) => handleMouseDown("LR", e.nativeEvent)}
                />

                <div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={detailTableRef}>
                    <Detailtable_PRD3060_R01 />
                </div>
            </div>

            <Message />
        </div>
    );
};
